// PWA helpers EXCLUSIVOS do Portal do Cliente. NAO altera o SW nem o manifest global.
// Reutiliza o service worker global (escopo "/") que ja controla /cliente/ e NUNCA cacheia /api/*.

export const PORTAL_PATH_RE = /^\/cliente(\/|$)/;
export const isPortalPath = (p) => PORTAL_PATH_RE.test(p || "");

// Manifest com que a pagina foi carregada (definido no <head> do index.html antes do React).
export function bootKind() {
  return (typeof window !== "undefined" && window.__PWA_BOOT__) || "global";
}

function currentManifestKind() {
  const link = typeof document !== "undefined" && document.querySelector('link[rel="manifest"]');
  return link && /manifest-cliente\.json$/.test(link.getAttribute("href") || "") ? "portal" : "global";
}

let deferredPrompt = null;
const listeners = new Set();

if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    // So aceita pedido de instalacao gerado com o manifest do Portal desde o carregamento.
    if (bootKind() !== "portal" || currentManifestKind() !== "portal") return;
    deferredPrompt = e;
    listeners.forEach((fn) => fn(true));
  });
  window.addEventListener("appinstalled", () => {
    deferredPrompt = null;
    listeners.forEach((fn) => fn(false));
  });
}

export function onInstallAvailability(fn) {
  listeners.add(fn);
  fn(!!deferredPrompt);
  return () => listeners.delete(fn);
}

export function canPromptInstall() {
  return !!deferredPrompt;
}

// Pagina carregada com outro manifest (navegacao interna vinda do admin/revendedora)?
// Entao a instalacao exige navegacao completa para /cliente/acesso.
export function needsFullReloadForInstall() {
  return bootKind() !== "portal";
}

export function reloadIntoPortalAccess() {
  window.location.assign("/cliente/acesso");
}

export async function promptInstall() {
  if (needsFullReloadForInstall()) { deferredPrompt = null; reloadIntoPortalAccess(); return "reloading"; }
  if (!deferredPrompt) return "unavailable";
  deferredPrompt.prompt();
  const choice = await deferredPrompt.userChoice.catch(() => ({ outcome: "dismissed" }));
  deferredPrompt = null;
  listeners.forEach((f) => f(false));
  return choice.outcome; // "accepted" | "dismissed"
}

export function isStandalone() {
  if (typeof window === "undefined") return false;
  return window.matchMedia("(display-mode: standalone)").matches ||
    window.navigator.standalone === true;
}

export function isIOS() {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent || "";
  const iDevice = /iPad|iPhone|iPod/.test(ua);
  const iPadOS = navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;
  return iDevice || iPadOS;
}

export function isInApp() {
  // navegador interno (Instagram/Facebook/etc.) onde instalar nao e possivel
  const ua = (navigator.userAgent || "").toLowerCase();
  return /instagram|fban|fbav|line\/|micromessenger/.test(ua);
}

// Flag consumida pelo registrador global do SW (src/index.js) para NAO recarregar
// automaticamente durante login/PIX ou outra interacao em andamento.
export function setPortalBusy(v) {
  if (typeof window !== "undefined") window.__PORTAL_BUSY__ = !!v;
}

// Navegacao interna da SPA: mantem um unico <link rel=manifest> coerente com a rota.
export function applyManifestForPath(pathname) {
  if (typeof window !== "undefined" && window.__PWA_APPLY__) window.__PWA_APPLY__(isPortalPath(pathname) ? "portal" : "global");
}

// Banner de atualizacao: detecta um SW em espera (nova versao). Nao recarrega sozinho.
export async function checkWaitingUpdate(cb) {
  if (!("serviceWorker" in navigator)) return;
  try {
    const reg = await navigator.serviceWorker.getRegistration();
    if (!reg) return;
    if (reg.waiting) cb(reg);
    reg.addEventListener("updatefound", () => {
      const nw = reg.installing;
      if (!nw) return;
      nw.addEventListener("statechange", () => {
        if (nw.state === "installed" && navigator.serviceWorker.controller) cb(reg);
      });
    });
  } catch { /* noop */ }
}

export function applyWaitingUpdate(reg) {
  if (reg && reg.waiting) reg.waiting.postMessage("SKIP_WAITING");
  // o controllerchange global recarrega uma vez quando a nova versao assume
}
